import { i18n, vuetify } from '@plugins/vuetify';
import store from '@store';
import Vue from 'vue';
import VueExcelXlsx from 'vue-excel-xlsx';
import VueSanitize from 'vue-sanitize';
import VueSession from 'vue-session';
import App from './App.vue';
import router from './router';

Vue.use(VueExcelXlsx);
Vue.use(VueSanitize);
Vue.use(VueSession, { persist: false });

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
